import { ClaimApi, CoreFetch } from '@enter/core';
import type { CoderRuleSuppressionApi } from '@enter/core';
import { ClaimService } from './claim.service';

export const coderRuleSuppressionApi: CoderRuleSuppressionApi = {
    listSuppressed: (id: string) => CoreFetch<ClaimApi>(ClaimApi).listProviderClaimSuppressedCoderRules({ id }),
    listCodings: (ids: string[]) => ClaimService.fetchCodingsByClaimIds(ids),
    suppress: async (id: string, ruleNumber: number) => {
        await CoreFetch<ClaimApi>(ClaimApi).suppressProviderClaimCoderRule({ id, ruleNumber });
    },
    unsuppress: async (id: string, ruleNumber: number) => {
        await CoreFetch<ClaimApi>(ClaimApi).unsuppressProviderClaimCoderRule({ id, ruleNumber });
    },
};
